var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.872,
    height: 16.713,
    viewBox: "0 0 18.872 16.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16600",
    "data-name": "Group 16600",
    transform: "translate(-579.367 -402.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16599",
    "data-name": "Group 16599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-media-1370823",
    transform: "translate(527.289 98.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11517",
    "data-name": "Path 11517",
    d: "M161.315,93.833a.253.253,0,0,0,.113-.193.223.223,0,0,0-.113-.193l-1.957-1.114a.254.254,0,0,0-.247,0,.285.285,0,0,0-.135.193v2.227Zm-1.071.389a1.268,1.268,0,0,0,.464-.56l-1.238.707A1.627,1.627,0,0,0,160.244,94.222Zm-6.016-9h2.43a.236.236,0,1,0,0-.471h-2.43a.244.244,0,0,0-.248.236A.231.231,0,0,0,154.228,85.223Zm0,1.885H159a.236.236,0,1,0,0-.471h-4.77a.236.236,0,1,0,0,.471Zm11.5,1.242h-4.3V84.944c0-.064-.022-.128-2.857-2.763a.263.263,0,0,0-.18-.064h-6.165a.244.244,0,0,0-.247.236l.056,9.981,1.938-1.885.5.181.224,5.979-.39.52L165.7,97.11a.244.244,0,0,0,.248-.236V88.585a.225.225,0,0,0-.225-.236Zm-7.155-5.5,2.07,1.928h-2.07Zm-6.1-.257h5.6v2.4a.244.244,0,0,0,.247.236h2.61V88.35h-6.7a.244.244,0,0,0-.247.236l-.008,1.863-1.45,1.139ZM165.478,96.66l-10.779.095c0-.593-.224-5.816-.224-6.306h11Zm0-6.661h-11V88.821h11Z",
    transform: "translate(-95 222)",
    fill: "var(--mainColor)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_icon-social-twitter_211920",
    "data-name": "iconfinder icon-social-twitter 211920",
    d: "M-281.338,65.5a4.241,4.241,0,0,1-1.178.314,2.006,2.006,0,0,0,.9-1.1,4.149,4.149,0,0,1-1.3.481,2.1,2.1,0,0,0-2.9-.095,1.959,1.959,0,0,0-.65,1.454,1.893,1.893,0,0,0,.053.453,5.876,5.876,0,0,1-4.229-2.08,1.957,1.957,0,0,0,.636,2.657,2.048,2.048,0,0,1-.93-.248v.025a2.006,2.006,0,0,0,1.645,1.952,2.118,2.118,0,0,1-.54.07,1.982,1.982,0,0,1-.386-.037,2.048,2.048,0,0,0,1.92,1.382,4.2,4.2,0,0,1-2.549.852,4.216,4.216,0,0,1-.489-.028,5.877,5.877,0,0,0,3.142.9,5.708,5.708,0,0,0,5.84-5.664c0-.085,0-.172-.006-.257A4.132,4.132,0,0,0-281.338,65.5Z",
    transform: "translate(870.836 346.51)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11518",
    "data-name": "Path 11518",
    d: "M.275-.162.45,5.014",
    transform: "translate(586.5 411.637)",
    fill: "#fafafa",
    stroke: "#fafafa",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToGroup);
export default __webpack_public_path__ + "static/media/IconToGroup.63fe6255945cd410d4b8b58ccc3144bf.svg";
export { ForwardRef as ReactComponent };